export function formatEuro(value, locale = undefined) {
  if (value == null || value === '') return '';

  const numeric = typeof value === 'number' ? value : (() => {
    if (typeof value !== 'string') return NaN;
    const cleaned = value
      .replace(/(USD|EUR)/gi, '')
      .replace(/[€$]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(',', '.');
    const parsed = parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : NaN;
  })();

  if (Number.isFinite(numeric)) {
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: numeric % 1 === 0 ? 0 : 2,
      }).format(numeric);
    } catch (e) {
      // fall through
    }
  }

  const fallback = String(value)
    .replace(/(USD|EUR)/gi, '')
    .replace(/[€$]/g, '')
    .trim();
  return fallback ? `€${fallback}` : '';
}

export function formatCurrencyAmount(value, currency = 'EUR', locale = undefined) {
  if (value == null || value === '') return '';

  const numeric = typeof value === 'number' ? value : (() => {
    const cleaned = String(value)
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');
    const parsed = Number.parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : NaN;
  })();

  if (!Number.isFinite(numeric)) return String(value);

  const safeCurrency = String(currency || 'EUR').trim().toUpperCase() || 'EUR';

  try {
    return new Intl.NumberFormat(locale || undefined, {
      style: 'currency',
      currency: safeCurrency,
      maximumFractionDigits: numeric % 1 === 0 ? 0 : 2,
    }).format(numeric);
  } catch (_error) {
    return `${numeric.toFixed(2)} ${safeCurrency}`;
  }
}
